<div class="page-container">
    <!-- Tabs -->
    <div class="page-tabs-row">
        <div class="page-tabs">
            @for (tab of columns; track tab.key) {
                <button class="page-tab"
                    [class.active]="activeTab === tab.key"
                    (click)="changeTab(tab.key)">
                    {{ tab.title }} ({{ getEnquiriesByStatus(tab.key).length }})
                </button>
            }
        </div>
        @if (!isAdmin) {
            <button class="page-tab page-tab-add" (click)="navigateToAdd()">
                <hugeicons-icon [icon]="addIcon" [size]="16" color="currentColor"></hugeicons-icon>
                Add Inquiry
            </button>
        }
    </div>

    <!-- Filters -->
    <div class="filters-bar">
        <div class="search-input">
            <hugeicons-icon [icon]="searchIcon" [size]="16" class="search-icon"></hugeicons-icon>
            <input type="text" placeholder="Search inquiries..." [value]="searchTerm" (input)="onSearchInput($event)">
        </div>
        <div class="date-filter">
            <app-date-picker [(ngModel)]="filterDate" placeholder="Filter by date" [highlightDates]="enquiryDates" (ngModelChange)="onFilterChange()"></app-date-picker>
        </div>
    </div>

    <!-- Content -->
    <div class="content-wrapper">
        <div class="tab-content card">
            @if (getTotalFilteredEnquiries() > 0) {
            <div class="enquiry-table-wrapper">
                <table class="enquiry-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Client Name</th>
                            <th>Injury Type</th>
                            <th>Incident Date</th>
                            <th>Attorney</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of getFilteredEnquiries(); track item) {
                        <tr>
                            <td><span class="enquiry-id">{{ item.id }}</span></td>
                            <td style="text-transform: capitalize;">{{ item.client_name }}</td>
                            <td>{{ item.injury_type }}</td>
                            <td>{{ item.incident_date | date }}</td>
                            <td>{{ item.attorney_name }}</td>
                            <td class="actions-cell">
                                <div class="actions-wrapper">
                                    @if (!isAdmin && canSubmitCase(item)) {
                                    <button class="btn btn-sm btn-primary submit-case-btn"
                                        (click)="navigateToSubmitCase(item, $event)"
                                        title="Submit case details for this inquiry">
                                        <hugeicons-icon [icon]="submitCaseIcon" [size]="14"></hugeicons-icon>
                                        Submit Case Details
                                    </button>
                                    }
                                    @if (isAdmin && isAcceptedStatus(item) && item.has_submission !== 1) {
                                    <span class="pending-badge">Case Details Pending</span>
                                    }
                                    <button class="btn-icon" (click)="viewDetails(item)">
                                        <hugeicons-icon [icon]="viewIcon" [size]="18"></hugeicons-icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            } @else {
            <app-empty-state
                [icon]="getActiveColumn().noDataIcon"
                [title]="getActiveColumn().noDataTitle"
                [description]="getActiveColumn().noDataDescription">
            </app-empty-state>
            }
        </div>
    </div>
</div>
